import Header from "../../components/Header/Header";
import Service from "../../components/Service/Service";

const LandingPage = () => {
  return (
    <>
      <Header />
      <Service />
    </>
  );
};

export default LandingPage;
